// src/components/about/TeamSection.js
import React from 'react';
import TeamMemberCard from './TeamMemberCard';
import AnimateOnScroll from './AnimateOnScroll';

// Define team data here or import it
const teamMembers = [
   {
    id: 'joseph',
    name: 'Dr. Joseph M Levermore',
    title: 'Founder / CEO',
    affiliations: ['School of Public Health'], // Keep dynamic affiliations
    description: 'Dr. Joseph Levermore is an Optical Physicist and AI Engineer at Eden Tech. Previously, he was a Research Associate at the Medical Research Council (MRC) Centre for Environment and Health, School of Public Health.',
    imageSrc: "https://firebasestorage.googleapis.com/v0/b/plasticanalytics-ada31.appspot.com/o/landingPage%2FteamMembers%2Fjoseph_levermore.png?alt=media&token=67ca23de-3e87-43c0-9492-aaa5d2b99f17", // Use updated placeholder
    links: {
       twitter: 'https://www.linkedin.com/in/josephlevermore/', // Assuming this is twitter
       email: 'joseph.levermore@eden-microfluidics.com',
       researchGate: 'https://www.researchgate.net/profile/Joseph-Levermore/'
     }
  },
  {
    id: 'frank',
    name: 'Professor Frank J Kelly',
    title: 'Program Lead',
    affiliations: ['School of Public Health'],
    description: 'Professor Frank Kelly, PhD, FKC, FRSB, FRSC, FMedSci, holds the inaugural Humphrey Battcock Chair in Community Health and Policy within the School of Public Health, in a new global centre of air pollution research.',
    imageSrc: "https://firebasestorage.googleapis.com/v0/b/plasticanalytics-ada31.appspot.com/o/landingPage%2FteamMembers%2Ffrank_kelly.png?alt=media&token=54c589c9-699c-40e3-928b-f166b475a4dc",
    links: {
       twitter: 'https://twitter.com/centreenvhealth/', // Assuming this is twitter
       email: 'frank.kelly@imperial.ac.uk',
       researchGate: 'https://www.researchgate.net/profile/Frank-Kelly-5/'
     }
  },
  {
    id: 'stephanie',
    name: 'Dr. Stephanie L Wright',
    title: 'Founder', // Assuming "Founder" relates to the Microplastics team lead role
    affiliations: ['School of Public Health'],
    description: 'Dr. Stephanie Wright is a Lecturer at the Medical Research Council (MRC) Centre for Environment and Health, School of Public Health. She now holds a UKRI Rutherford Fellowship and leads the Microplastics team.',
    imageSrc: "https://firebasestorage.googleapis.com/v0/b/plasticanalytics-ada31.appspot.com/o/landingPage%2FteamMembers%2Fstephanie_wright.png?alt=media&token=78e51499-77f0-4c2e-bf3d-0597f4593dc5",
    links: {
       twitter: 'https://uk.linkedin.com/in/stephanie-wright-b21a0889',
       email: 's.wright19@imperial.ac.uk',
       researchGate: 'https://www.researchgate.net/profile/Stephanie-Wright-15/'
     }
  },
];


const TeamSection = () => {
  return (
    <div style={{
      borderTop: '1px solid #e5e5e5',
      paddingTop: '60px',
      marginBottom: '80px',
    }}>
      {/* Animate the title separately */}
      <AnimateOnScroll>
        <h2 style={{
          textAlign: 'center',
          fontSize: '2rem',
          fontWeight: 'normal',
          marginBottom: '60px',
        }}>
          OUR TEAM
        </h2>
      </AnimateOnScroll>

      {/* Grid for team members - Each card animates individually */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
        gap: '40px',
      }}>
        {teamMembers.map((member, index) => (
          <TeamMemberCard
             key={member.id}
             member={member}
             delay={index * 100} // Stagger animation slightly
          />
        ))}
      </div>
    </div>
  );
};

export default TeamSection;